var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.is_loading
        ? _c("div", { staticClass: "text-muted py-3" }, [
            _c("i", { staticClass: "fa fa-spinner fa-spin me-1" }),
            _vm._v(" Memuat CPPT...\n    "),
          ])
        : _vm.rows.length
        ? [
            _c("div", { staticClass: "d-flex justify-content-end mb-2" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-sm btn-outline-danger",
                  attrs: { disabled: _vm.is_exporting },
                  on: { click: _vm.unduhPdf },
                },
                [
                  _c("i", {
                    staticClass: "me-1",
                    class: _vm.is_exporting
                      ? "fa fa-spinner fa-spin"
                      : "fa fa-file-pdf",
                  }),
                  _vm._v(
                    "\n                Export PDF (" +
                      _vm._s(_vm.count) +
                      " catatan)\n            "
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "table-responsive" }, [
              _c(
                "table",
                {
                  staticClass:
                    "table table-bordered align-middle mb-0 cppt-table",
                },
                [
                  _vm._m(0),
                  _vm._v(" "),
                  _vm._l(_vm.rows, function (row) {
                    return _c(
                      "tbody",
                      { key: row.IdCPPT },
                      _vm._l(_vm.uraian(row), function (soap, index) {
                        return _c("tr", { key: `${row.IdCPPT}-${soap.kode}` }, [
                          index === 0
                            ? _c(
                                "td",
                                {
                                  staticClass: "text-center",
                                  attrs: { rowspan: 4 },
                                },
                                [
                                  _c("div", [
                                    _vm._v(
                                      _vm._s(_vm.formatTanggal(row.CreatedAt))
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "small text-muted" },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.formatJam(row.CreatedAt))
                                      ),
                                    ]
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "td",
                            { staticClass: "text-center fw-bold soap-kode" },
                            [_vm._v(_vm._s(soap.kode))]
                          ),
                          _vm._v(" "),
                          _c("td", { staticClass: "pre-wrap" }, [
                            _vm._v(_vm._s(soap.isi || "")),
                          ]),
                          _vm._v(" "),
                          index === 0
                            ? _c(
                                "td",
                                {
                                  staticClass: "pre-wrap align-top small",
                                  attrs: { rowspan: 4 },
                                },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(_vm.instruksi(row) || "") +
                                      "\n                        "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          index === 0
                            ? _c(
                                "td",
                                {
                                  staticClass: "align-top small",
                                  attrs: { rowspan: 4 },
                                },
                                [
                                  row.TandaTangan
                                    ? _c(
                                        "div",
                                        { staticClass: "mb-1 text-center" },
                                        [
                                          _c("img", {
                                            staticStyle: {
                                              "max-width": "100px",
                                              "max-height": "50px",
                                            },
                                            attrs: {
                                              src:
                                                "/storage/signatures/" +
                                                row.TandaTangan,
                                              alt: "Tanda Tangan",
                                            },
                                          }),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "fw-semibold" }, [
                                    _vm._v(
                                      _vm._s(row.SavedBy || row.name || "-")
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "text-muted" }, [
                                    _vm._v(
                                      _vm._s(_vm.formatTanggal(row.CreatedAt))
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  row.DiisiOleh
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "badge bg-light text-dark border mt-1",
                                        },
                                        [
                                          _vm._v(
                                            "\n                                " +
                                              _vm._s(row.DiisiOleh) +
                                              "\n                            "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  row.ApproveCPPT
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "text-success small mt-1",
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "fa fa-check-circle",
                                          }),
                                          _vm._v(
                                            " Read back\n                                " +
                                              _vm._s(
                                                _vm.formatTanggal(
                                                  row.ApproveCPPTDate
                                                )
                                              ) +
                                              "\n                            "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          index === 0
                            ? _c(
                                "td",
                                {
                                  staticClass: "align-top small",
                                  attrs: { rowspan: 4 },
                                },
                                [
                                  _c("div", [_vm._v(_vm._s(_vm.unit(row)))]),
                                  _vm._v(" "),
                                  row.Poli
                                    ? _c("div", { staticClass: "text-muted" }, [
                                        _vm._v(_vm._s(row.Poli)),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  row.Regno
                                    ? _c("div", { staticClass: "text-muted" }, [
                                        _vm._v("No. Reg " + _vm._s(row.Regno)),
                                      ])
                                    : _vm._e(),
                                ]
                              )
                            : _vm._e(),
                        ])
                      }),
                      0
                    )
                  }),
                ],
                2
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "d-flex flex-wrap align-items-center justify-content-between gap-2 mt-2",
              },
              [
                _c("span", { staticClass: "text-muted small" }, [
                  _vm._v(
                    "\n                Halaman " +
                      _vm._s(_vm.page) +
                      " — " +
                      _vm._s(_vm.rows.length) +
                      " dari " +
                      _vm._s(_vm.count) +
                      " catatan\n            "
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "btn-group btn-group-sm" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-outline-secondary",
                      attrs: { disabled: !_vm.previous_page },
                      on: {
                        click: function ($event) {
                          return _vm.pindahHalaman(_vm.previous_page)
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "fa fa-chevron-left" }),
                      _vm._v(" Sebelumnya\n                "),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-outline-secondary",
                      attrs: { disabled: !_vm.next_page },
                      on: {
                        click: function ($event) {
                          return _vm.pindahHalaman(_vm.next_page)
                        },
                      },
                    },
                    [
                      _vm._v("\n                    Berikutnya "),
                      _c("i", { staticClass: "fa fa-chevron-right" }),
                    ]
                  ),
                ]),
              ]
            ),
          ]
        : _c("p", { staticClass: "text-muted mb-0" }, [
            _c("i", { staticClass: "fa fa-inbox me-1" }),
            _vm._v(
              "\n        Tidak ada CPPT " +
                _vm._s(_vm.label_jenis) +
                " untuk pasien ini.\n    "
            ),
          ]),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", { staticClass: "table-light text-center" }, [
      _c("tr", [
        _c("th", { staticStyle: { width: "130px" } }, [
          _vm._v("Tanggal dan Jam Pemeriksaan"),
        ]),
        _vm._v(" "),
        _c("th", { attrs: { colspan: "2" } }, [_vm._v("Uraian Pemeriksaan")]),
        _vm._v(" "),
        _c("th", { staticStyle: { width: "200px" } }, [
          _vm._v("Instruksi DPJP"),
        ]),
        _vm._v(" "),
        _c("th", { staticStyle: { width: "170px" } }, [
          _vm._v(
            "\n                            Nama & Tanda Tangan DPJP / Tenaga Kesehatan\n                        "
          ),
        ]),
        _vm._v(" "),
        _c("th", { staticStyle: { width: "110px" } }, [_vm._v("Unit")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }